import {
  Button,
  Grid,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Space,
  Text,
  TextLabel,
} from '@tonic-one/react';
import { useTranslation } from 'react-i18next';
import {
  DlpExpressionsModalNameEnum,
  DlpExpressionsModalState,
} from '../../type';
import { PolicyApi } from '@Apis';
import LoadingBtn from '@Components/Common/LoadingBtn';

export const DeleteModal = ({
  modalState,
  onClose,
  refreshTable,
}: {
  modalState: DlpExpressionsModalState;
  onClose: () => void;
  refreshTable: () => void;
}) => {
  const { t } = useTranslation(['common', 'policy']);

  const deleteDlpExpression = async () => {
    try {
      await PolicyApi.deleteDlpExpressionById(modalState.data.cfgIndex);
      window.showNotification({
        titleMsg: t('policy.dataIdentifiers.expressions.deleteSuccessfully'),
        severity: 'success',
      });
    } catch (error: any) {
      console.error(error);
      const errorCode = error?.data?.error?.details?.[0]?.code;
      if (errorCode === -116) {
        window.showNotification({
          titleMsg: t(
            'errors.policy.POLICY_API;DELETE_EXPRESSION_FAILURE;-116',
            {
              param: modalState.data.dpExpressionName,
            }
          ),
          severity: 'error',
        });
        return;
      }
      window.showNotification({
        titleMsg: t('common.apiException.internalError'),
        severity: 'error',
      });
    } finally {
      refreshTable();
      onClose();
    }
  };

  if (modalState.name !== DlpExpressionsModalNameEnum.Delete) {
    return <></>;
  }
  return (
    <Modal
      ensureFocus={true}
      autoFocus={false}
      closeOnEsc={true}
      closeOnOutsideClick={false}
      isClosable={true}
      isOpen={modalState.name === DlpExpressionsModalNameEnum.Delete}
      onClose={onClose}
      size="sm"
    >
      <ModalOverlay opacity={0.9} />
      <ModalContent>
        <ModalBody>
          <Text>{t('policy.dataIdentifiers.expressions.deleteConfirm')}</Text>
          <Grid
            gridTemplateColumns="max-content auto"
            gridColumnGap="4px"
            gridRowGap="8px"
            pt="16px"
          >
            <TextLabel>{t('common.label.enterName')}:</TextLabel>
            <Text>{modalState.data.dpExpressionName}</Text>
            <TextLabel>{t('common.label.description')}:</TextLabel>
            <Text>{modalState.data.dpExpressionDesc}</Text>
          </Grid>
        </ModalBody>
        <ModalFooter>
          <LoadingBtn onClick={deleteDlpExpression} variant="primary">
            {t('common.button.ok')}
          </LoadingBtn>
          <Space width="2x" />
          <Button minWidth="20x" onClick={onClose}>
            {t('common.button.cancel')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
